import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        loading: false,
        plans: [],
        current_plan: {plan: null, usage: null},
        upgrading: false,
        checkout_status: null,
    },
    getters: {
        loading: state => state.loading,
        plans: state => state.plans,
        current_plan: state => state.current_plan,
        upgrading: state => state.upgrading,
        checkout_status: state => state.checkout_status,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setPlans(state, data) {
            state.plans = data
        },
        setCurrentPlan(state, data) {
            state.current_plan = data
        },
        setUpgrading(state, val) {
            state.upgrading = val
        },
        setCheckoutStatus(state, val) {
            state.checkout_status = val
        },
    },
    actions: {
        async getPlans({commit}) {
            try {
                commit('setLoading', true)
                const response = await api.getPlans();
                commit('setPlans', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async getCurrentPlan({commit}) {
            try {
                commit('setLoading', true)
                const response = await api.getCurrentPlan();
                commit('setCurrentPlan', response.data);
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        // Kicks off the M-Pesa STK push (PaymentController::upgradePlan()), then
        // polls the same /checkout-request-status endpoint every other STK push
        // flow in this app uses (see payments.store.js's getPaymentStatus) until
        // the callback lands and plan_id actually updates server-side.
        async upgradePlan({commit, dispatch}, data) {
            commit('setCheckoutStatus', null);
            try {
                commit('setUpgrading', true)
                const response = await api.upgradePlan(data);
                ElMessage.success(response.message || 'We sent a payment request. Please enter your M-Pesa PIN.');
                dispatch('pollUpgradeStatus', response.data.checkout_request_id);
                return true;
            } catch (e) {
                commit('setUpgrading', false)
                ElMessage.error(e.response.data.message);
                return false;
            }
        },

        pollUpgradeStatus({commit, dispatch}, checkoutRequestId) {
            const timer = setInterval(async () => {
                try {
                    const response = await api.getPaymentStatus({checkout_request_id: checkoutRequestId});
                    if (response.status === 'Completed') {
                        clearInterval(timer);
                        commit('setUpgrading', false)
                        commit('setCheckoutStatus', 'Completed');
                        ElMessage.success('Plan upgraded successfully!');
                        dispatch('getCurrentPlan');
                    } else if (response.status === 'Failed') {
                        clearInterval(timer);
                        commit('setUpgrading', false)
                        commit('setCheckoutStatus', 'Failed');
                        ElMessage.error('The payment could not be completed. Please try again.');
                    }
                    // anything else (still pending) - keep polling
                } catch (e) {
                    // a transient status-check failure shouldn't abort the wait
                }
            }, 3000);
        },
    }
}
